import { render, staticRenderFns } from "./OfertaGard.vue?vue&type=template&id=fb75f626&scoped=true"
import script from "./OfertaGard.vue?vue&type=script&lang=js"
export * from "./OfertaGard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb75f626",
  null
  
)

export default component.exports